import { restRequest } from "vrcore-dashboard/dist/utilities";

export const GET_REPORT_TITLES = restRequest(
    "VRCORE_DAILYWS_LIST.GET_REPORT_TITLES"
);
export const GET_USER_DATA = restRequest("VRCORE_DAILYWS_LIST.GET_USER_DATA");
export const SET_FILTER_JOB_STAGE = "VRCORE_DAILYWS_LIST.SET_FILTER_JOB_STAGE";
export const SET_FILTER_USER_UID = "VRCORE_DAILYWS_LIST.SET_FILTER_USER_UID";
export const SET_SEARCH_DATE_FROM = "VRCORE_DAILYWS_LIST.SET_SEARCH_DATE_FROM";
export const SET_SEARCH_DATE_TO = "VRCORE_DAILYWS_LIST.SET_SEARCH_DATE_TO";
export const SET_REPORT_FILTER_STATE =
    "VRCORE_DAILYWS_LIST.SET_REPORT_FILTER_STATE";
export const SET_ROWS_PER_PAGE = "VRCORE_DAILYWS_LIST.SET_ROWS_PER_PAGE";
export const SET_PAGE = "VRCORE_DAILYWS_LIST.SET_PAGE";
export const SET_REPORT_STATUS = restRequest(
    "VRCORE_DAILYWS_LIST.SET_REPORT_STATUS"
);
export const SET_SELECTED_ROW = "VRCORE_DAILYWS_LIST.SET_SELECTED_ROW";
export const SET_REPORT_EDIT_STATUS = restRequest(
    "VRCORE_DAILYWS_LIST.SET_REPORT_EDIT_STATUS"
);
export const SET_STATUS_CHANGE_MODAL_INFO =
    "VRCORE_DAILYWS_LIST.SET_STATUS_CHANGE_MODAL_INFO";
export const DELETE_REPORT = restRequest("VRCORE_DAILYWS_LIST.DELETE_REPORT");
export const SET_DELETE_STATUS = "VRCORE_DAILYWS_LIST.SET_DELETE_STATUS";
export const SET_FILTER_JOB_ID = "VRCORE_DAILYWS_LIST.SET_FILTER_JOB_ID";
export const SET_FILTER_YEAR = "VRCORE_DAILYWS_LIST.SET_FILTER_YEAR";
export const SET_FILTER_MONTH = "VRCORE_DAILYWS_LIST.SET_FILTER_MONTH";
